// extracted by mini-css-extract-plugin
export default {"swatch":"BeerDetails_swatch__TJQv7","name":"BeerDetails_name__M-1p2","score":"BeerDetails_score__-SE6V","facts":"BeerDetails_facts__E4HBK"};